import React from 'react';
import { textEllipsis } from '../../../shared/utils/constants';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.name'),
      field: 'name',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { name } = rowData;
        return (
          <span className="tooltop-test" title={name}>
            {name}
          </span>
        );
      },
    },
    { title: t('general.active'), field: 'activeDescription' },
    {
      title: t('general.students'),
      field: 'studentQuantity',
    },
  ];
}
